import { render, staticRenderFns } from "./SuggestedBlogPosts.vue?vue&type=template&id=36ec809e"
import script from "./SuggestedBlogPosts.vue?vue&type=script&lang=js"
export * from "./SuggestedBlogPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogCard: require('/vercel/path0/components/shared/BlogCard.vue').default,ContainerContent: require('/vercel/path0/components/shared/ContainerContent.vue').default})
